export const validateFileFormat = (file: File, acceptedFormats: string[]) => {
  if (!file.type) return { isValid: false, fileType: null };

  const type = file.type.split('/');
  if (!acceptedFormats.includes(type[type.length - 1]))
    return { isValid: false, fileType: file.type };

  return { isValid: true, fileType: file.type };
};
